import React, { useContext, useState } from "react";
import ViewLineups from "./ViewLineups";
import { GreenMachineContext } from "../GreenMachineContext";
import { commitMutation, graphql, QueryRenderer } from "react-relay";
import environment from "../../../../../RelayEnvironment";
import "./ViewLineupsPage.css";
import relayEnvironment from "../../../../../RelayEnvironment";
import { isSiteAdmin } from "../../../../../AuthUtils";
import LineupsDisplay from "./LineupsDisplay";

const GET_LINEUP_SETS = graphql`
  query ViewLineupsPageQuery($gmID: ID!) {
    whoAmI {
      groups {
        name
      }
    }

    lineupSetsForGreenMachineSession(greenMachineSessionId: $gmID) {
      id
      createdAt
    }
  }
`;

const REPORT_ERROR = graphql`
  mutation ViewLineupsPageErrorReportMutation(
    $greenMachineSessionID: ID!
    $error: String!
  ) {
    reportGreenMachineError(
      input: { greenMachineSessionId: $greenMachineSessionID, error: $error }
    ) {
      success
    }
  }
`;

export default function ViewLineupsPage() {
  const {
    greenMachineSessionID,
    selectedSlateID,
    currentStage,
    STAGE_NUMBERS,
  } = useContext(GreenMachineContext);

  const STAGE_NUMBER = STAGE_NUMBERS.viewLineups;
  console.log(selectedSlateID);

  const [selectedBuildID, setSelectedBuildID] = useState(undefined);
  const [latestBuildCount, setLatestBuildCount] = useState(0);
  const [activeGmSessionID, setActiveGmSessionID] = useState(undefined);
  const [numRefetches, setNumRefetchs] = useState(0);
  const [errorReported, setErrorReported] = useState(false);

  if (currentStage < STAGE_NUMBER) {
    return null;
  }

  function loadNewBuild(e, buildID) {
    e.preventDefault();
    setSelectedBuildID(buildID);
  }

  function refetch(clearSelectedBuildID) {
    if (clearSelectedBuildID) {
      setSelectedBuildID(undefined);
      setLatestBuildCount(0);
    }
    setNumRefetchs(numRefetches + 1);
  }

  return (
    <QueryRenderer
      environment={environment}
      query={GET_LINEUP_SETS}
      variables={{
        gmID: greenMachineSessionID,
        numRefetches: numRefetches,
      }}
      fetchPolicy={"network-only"}
      render={({ error, props }) => {
        if (error) {
          return <div>Something went wrong.</div>;
        }

        if (!props) {
          return (
            <div className="gm-view-lineups-header-container">
              Loading lineups...
            </div>
          );
        }

        if (selectedBuildID === undefined) {
          setSelectedBuildID(props.lineupSetsForGreenMachineSession[0].id);
        }

        if (props.lineupSetsForGreenMachineSession.length > latestBuildCount) {
          setLatestBuildCount(props.lineupSetsForGreenMachineSession.length);
          setSelectedBuildID(
            props.lineupSetsForGreenMachineSession[
              props.lineupSetsForGreenMachineSession.length - 1
            ].id
          );
        }

        if (selectedBuildID === undefined) {
          return <div>Something went wrong.</div>;
        }

        return (
          <div>
            <div className="gm-view-lineups-header-container">
              {isSiteAdmin(props.whoAmI.groups) ? (
                !errorReported ? (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      commitMutation(relayEnvironment, {
                        mutation: REPORT_ERROR,
                        variables: {
                          greenMachineSessionID: greenMachineSessionID,
                          error: "Admin Report",
                        },
                        onCompleted: (content, errors) => {
                          setErrorReported(true);
                        },
                      });
                    }}
                  >
                    Report Issue
                  </button>
                ) : (
                  <span>Issue reported.</span>
                )
              ) : null}
              <br />
              <br />
              <div className="gm-builds-list">
                {props.lineupSetsForGreenMachineSession.map(
                  (lineupSet, index) => {
                    return (
                      <div
                        className={
                          "gm-build-select " +
                          (lineupSet.id === selectedBuildID
                            ? "gm-build-selected"
                            : "")
                        }
                        key={lineupSet.id}
                        onClick={(e) => loadNewBuild(e, lineupSet.id)}
                        onKeyPress={(e) => loadNewBuild(e, lineupSet.id)}
                        role="button"
                        tabIndex={0}
                      >
                        {index + 1}
                      </div>
                    );
                  }
                )}
              </div>
            </div>

            <React.Suspense fallback="Loading lineups...">
              <LineupsDisplay
                lineupSetID={selectedBuildID}
                refetch={refetch}
                numRefetches={numRefetches}
              />
            </React.Suspense>
          </div>
        );
      }}
    />
  );
}
